import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from "@wordpress/element";
import { __ } from "@wordpress/i18n";
import { useParams } from "react-router-dom";
import { CustomFieldEntityType } from "../../../../types/custom-field";
import { UserPageTaskContext, UserPageTaskContextProvider, } from "../../../providers/UserPageTaskContextProvider";
import { CustomFieldsWrap } from "../../CustomField/CustomFieldsWrap/CustomFieldsWrap";
import { PageContentWrap, PageTitle, PageWrap } from "../Page/Page";
import { TaskControls } from "./TaskControls/TaskControls";
import { TaskDetails } from "./TaskDetails/TaskDetails";
import { TaskDoneStatus } from "./TaskDoneStatus/TaskDoneStatus";
import { TaskStageSelect } from "./TaskStageSelect/TaskStageSelect";
function TaskPage() {
    const { taskHash } = useParams();
    return (_jsx(UserPageTaskContextProvider, { taskHash: taskHash, children: _jsx(TaskPageContent, {}) }));
}
function TaskPageContent() {
    const { state: { loading, task, customFields }, loadTask, } = useContext(UserPageTaskContext);
    return (_jsx(PageWrap, { loading: loading, onRefresh: loadTask, children: _jsxs(PageContentWrap, { children: [_jsxs(PageTitle, { children: [" ", __("Task details", "quicktasker")] }), task && (_jsxs("div", { className: "wpqt-flex wpqt-flex-col wpqt-items-center wpqt-gap-3", children: [_jsx(TaskDetails, { task: task }), _jsx(TaskStageSelect, { task: task }), _jsx(TaskDoneStatus, { task: task }), _jsx(CustomFieldsWrap, { entityId: task.id, entityType: CustomFieldEntityType.Task, entity: task, customFields: customFields }), _jsx(TaskControls, { task: task })] }))] }) }));
}
export { TaskPage };
